import React from 'react';
import classNames from 'classnames';
import 'app/component/Section.less';

export interface SectionProps {
    className: string;

    title?: React.ReactNode;

    content: React.ReactNode;
}

export const Section = (props: SectionProps) => {
    const componentClassName = classNames('section', props.className);

    return (
        <section className={componentClassName}>
            {props.title && <h6 className={'sectionTitle'}>{props.title}</h6>}
            {props.content}
        </section>
    );
};
